export default function(value, sign){
    return sign+value;
}
